import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { toast } from 'react-hot-toast';

const DeleteServiceDialog = ({ open, onClose, onSuccess, row, deleteService }) => {
  const [working, setWorking] = useState(false);

  const handleConfirm = async () => {
    if (!row?.id) return;
    setWorking(true);
    try {
      await deleteService(row.id);
      toast.success('Service deleted');
      onSuccess?.();
      onClose();
    } catch (error) {
      const err =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        'Failed to delete service';
      toast.error(typeof err === 'string' ? err : 'Failed to delete service');
    } finally {
      setWorking(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !working && onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>Delete service?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Do you want to delete the service?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={working}>
          Cancel
        </Button>
        <Button color="error" variant="contained" onClick={handleConfirm} disabled={working}>
          {working ? 'Deleting…' : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteServiceDialog;
